import axios from "axios";
import { LOGIN_USER_SERVER, 
  CREATE_CUSTOMER_ACCOUNT_SERVER,
  GET_CUSTOMER_ACCOUNT_SERVER,
  UPDATE_CUSTOMER_ACCOUNT_SERVER,
  GET_PROVINCES_SERVER,
  GET_DISTRICTS_SERVER,
  GET_WARDS_SERVER,
  GET_WISHLIST_SERVER,
  ADD_TO_WISHLIST_SERVER,
  GET_COMMENTS_SERVER,
  CREATE_COMMENT_SERVER,
} from "../../utils/misc";
import {
  LOGIN_USER,
  CREATE_USER,
  GET_CUSTOMER_ACCOUNT,
  UPDATE_CUSTOMER_ACCOUNT,
  GET_PROVINCES,
  GET_DISTRICTS,
  GET_WARDS,
  GET_WISHLIST,
  ADD_TO_WISHLIST,
  GET_COMMENTS,
  CREATE_COMMENT,
} from "./types";
import moment from 'moment';

export async function loginUser(dataToSubmit) {
  const data = { UserName: dataToSubmit.email, Password: dataToSubmit.password };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(LOGIN_USER_SERVER, { params: data }, { headers: headers }).then((res) => {
    let user = res.data
    if(res.data.success) {
      let result = res.data.data;
      localStorage.setItem("user", JSON.stringify(result.userData));
      localStorage.setItem("token", JSON.stringify(result.token));
    }
    return {
      user
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: LOGIN_USER,
    payload: request,
  };
}

export async function createUser(dataToSubmit) {
  const data = { 
    userName: dataToSubmit.email,
    password: dataToSubmit.password,
    customerName: dataToSubmit.fullName,
    address: dataToSubmit.address,
    wardId: dataToSubmit.wardId,
    districtId: dataToSubmit.districtId,
    provinceId: dataToSubmit.provinceId,
    email: dataToSubmit.email,
    homePhone: dataToSubmit.homePhone,
    birthDate: dataToSubmit.birthDate,
    identityNumber: dataToSubmit.identityNumber,
    dateRange: dataToSubmit.dateRange,
    issuePlace: dataToSubmit.issuePlace,
    categoryId: dataToSubmit.category
  };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.post(CREATE_CUSTOMER_ACCOUNT_SERVER, data, { headers: headers }).then((res) => {
    let result = res.data;
    return {
      result
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: CREATE_USER,
    payload: request,
  };
}

export async function getUser(dataToSubmit) {
  let token = JSON.parse(localStorage.getItem("token"));
  let config = {
    headers: {
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    params: {
      id: dataToSubmit
    },
  }
  //////////////////////
  const request = await axios.get(GET_CUSTOMER_ACCOUNT_SERVER, config).then((res) => {
    let user = res.data.data;
    return {
      user
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_CUSTOMER_ACCOUNT,
    payload: request,
  };
}

export async function updateUser(dataToSubmit) {
  let user = JSON.parse(localStorage.getItem("user"))
  const data = dataToSubmit
  data.accountId = user.accountId
  data.userName = user.userName

  let token = JSON.parse(localStorage.getItem("token"))
  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer ${token}`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.put(UPDATE_CUSTOMER_ACCOUNT_SERVER, data, { headers: headers }).then((res) => {
    let result = res.data;
    return {
      result
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: UPDATE_CUSTOMER_ACCOUNT,
    payload: request,
  };
}

export async function getProvinces() {
  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_PROVINCES_SERVER, { headers: headers }).then((res) => {
    let provinces = res.data.data;
    return {
      provinces
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: GET_PROVINCES,
    payload: request,
  };
}

export async function getDistricts(provinceId) {
  const data = { ProvinceId: provinceId };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_DISTRICTS_SERVER, { params: data }, { headers: headers }).then((res) => {
    let districts = res.data.data;
    return {
      districts
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: GET_DISTRICTS,
    payload: request,
  };
}

export async function getWards(districtId) {
  const data = { DistrictId: districtId };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_WARDS_SERVER, { params: data }, { headers: headers }).then((res) => {
    let wards = res.data.data;
    return {
      wards
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: GET_WARDS,
    payload: request,
  };
}

export async function getWishList(customerId, productId) {
  const data = { CustomerId: customerId, ProductId: productId ? productId : null };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_WISHLIST_SERVER, { params: data }, { headers: headers }).then((res) => {
    let wishList = res.data.data
    return {
      wishList
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: GET_WISHLIST,
    payload: request,
  };
}

export async function addToWishList(dataToSubmit) {
  let token = JSON.parse(localStorage.getItem("token"))
  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer ${token}`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.post(ADD_TO_WISHLIST_SERVER, dataToSubmit, { headers: headers }).then((res) => {
    let result = res.data;
    return {
      result
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: ADD_TO_WISHLIST,
    payload: request,
  };
}

export async function getComments(productId) {
  const data = { ProductId: productId };

  const headers = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + 'Thanh Tu Nguyen',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_COMMENTS_SERVER, { params: data }, { headers: headers }).then((res) => {
    let comments = res.data.data.map(element => {
      return {
        avatarUrl: element.avatarUrl,
        fullName: element.fullName,
        createdAt: new Date(element.createdAt),
        text: element.text
      }
    })
    return {
      comments
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: GET_COMMENTS,
    payload: request,
  };
}

export async function createComment(dataToSubmit) {
  let token = JSON.parse(localStorage.getItem("token"))
  
  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer ${token}`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.post(CREATE_COMMENT_SERVER, dataToSubmit, { headers: headers }).then((res) => {
    let result = res.data;
    return {
      result
    };
  }).catch(err=>{
    console.log(err)
  });
  return {
    type: CREATE_COMMENT,
    payload: request,
  };
}